import {
  Component,
  DoCheck,
  ViewEncapsulation,
} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {SessionStorageService} from "../../services/session-storage.service";
import { UtilsService } from "../../services/utils.service";
import {headerTittles} from "../../../shared/constants/header-tittle";

@Component({
    selector: "pme-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeaderComponent implements DoCheck {
  classificationIdentifier: string;
  classificationName: string;
  classificationNameNewHeader: string;
  isLogged: boolean;
  showUserData: boolean;
  userName: string;
  userEmail: string;
  isAttendance: boolean;
  showNewHeader: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public sessionStorageService: SessionStorageService,
    private utils: UtilsService
  ) {
    // Gets the current category on session or URL
    this.classificationIdentifier = this.sessionStorageService.checkAndSetClassification(this.route);
    this.classificationName = this.sessionStorageService.getClassificationName();
  }


  checkSelfAttendance() {
    this.isAttendance = sessionStorage.getItem('selfAttendance') === 'true';
    if (this.isAttendance) {
      this.userEmail = sessionStorage.getItem('email');
      this.userName = sessionStorage.getItem('name');
      if (this.userEmail && this.userName) {
        this.showUserData = true;
      } else {
        this.showUserData = false;
      }
    } else {
      this.showUserData = false;
    }
  }

  ngDoCheck() {
    this.isLogged = this.sessionStorageService.getIsLogged();
    this.classificationIdentifier = this.sessionStorageService.checkAndSetClassification(this.route);
    this.classificationName = this.sessionStorageService.getClassificationName();
    this.classificationNameNewHeader = headerTittles[this.classificationName];
    this.checkSelfAttendance();
    
    let currentStep = this.utils.getCurrentStep()
    if (currentStep){
      let classificationIdentifier = this.sessionStorageService.getClassification();
      this.showNewHeader = currentStep.index === 0 && classificationIdentifier != "saude-do-seu-negocio";
    }
  }
}
